module.exports = __webpack_public_path__ + "static/media/header-logo.a4af36b5.svg";